<script>
  import { _ } from "svelte-i18n";
  import { tags_are_being_edited } from "../stores";

  function toggle() {
    $tags_are_being_edited = !$tags_are_being_edited
  }
</script>

<span on:click={toggle} class:active={$tags_are_being_edited}>
  { $tags_are_being_edited ? $_('tags.finishEditing') : $_('tags.edit')}
</span>

<style>
  span {
    display: inline-block;
    white-space: nowrap;
    margin-right: 1rem;
    color: var(--c-text-faded);
    line-height: 3rem;
    font-weight: 500;
    letter-spacing: 0.05rem;
  }
  span:hover {
    cursor: pointer;
    color: var(--c-text);
  }
  span.active {
    color: var(--c-accent);
  }
</style>